import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import TableContent from "../../table/table";
import Loader from "../../../loader/loader";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../Notifcation";
import {
  CreateAgencyDestinationAction,
  UpdateAgencyDestinationAction,
} from "../../../../redux/actions/AgencyDestinationAction";
import { ToastContainer } from "react-toastify";
import {
  AddCourtAction,
  DeleteCourtAction,
  GetCourtAction,
  UpdateCourtAction,
} from "../../../../redux/actions/CourtAction";
const Mahkama = () => {
  const [NameMahkama, setNameMahkama] = useState("");
  const [AddreessMahkama, setAddreessMahkama] = useState("");
  const [Note, setNote] = useState("");
  const [IDmahkama, setIDmahkama] = useState("");
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setIDmahkama(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteCourtAction(IDmahkama));
    setLoading(false);
    setIDmahkama("");
    setshowDelete(false);
    setIsPress(false);
  };
  const ALL = useSelector((state) => state.CourtR.Courts);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetCourtAction());
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (NameMahkama === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      AddCourtAction({
        Name: NameMahkama,
        Description: Note,
        Address: AddreessMahkama,
      })
    );
    setNameMahkama("");
    setNote("");
    setAddreessMahkama("");
    setIDmahkama("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (NameMahkama === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateCourtAction({
        Id: IDmahkama,
        Name: NameMahkama,
        Description: Note,
        Address: AddreessMahkama,
      })
    );
    setNameMahkama("");
    setNote("");
    setAddreessMahkama("");
    setIDmahkama("");
    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };
  const Update = (item) => {
    setNameMahkama(item.Name);
    setNote(item.Description);
    setIDmahkama(item.Id);
    setAddreessMahkama(item.Address);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setNameMahkama(item.Name);
    setNote(item.Description);
    setIDmahkama(item.Id);
    setAddreessMahkama(item.Address);

    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.CourtR.AddCourts);
  const UP = useSelector((state) => state.CourtR.UpdateCourts);
  const DEL = useSelector((state) => state.CourtR.DeleteCourts);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "Great, Court created successfully"
          ) {
            dispatch(GetCourtAction());
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.data.StatusCode === 200 || UP.data.StatusCode === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage === "Great, Court updated Successfully"
          ) {
            dispatch(GetCourtAction());
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.StatusCode !== 200 || UP.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }

      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, Court deleted Successfully"
          ) {
            dispatch(GetCourtAction());
            notify("تم حذف المحكمة بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "can't delete this because you are using it"
          ) {
            notify("لا يمكن حذف هذة المحكمة لانها مستخدمة", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={NameMahkama}
                onChange={(e) => setNameMahkama(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    اسم المحكمة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={AddreessMahkama}
                onChange={(e) => setAddreessMahkama(e.target.value)}
                label={"العنوان"}
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                label="الوصف"
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم المحكمة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                العنوان <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الوصف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(ALL) && ALL.length > 0
              ? ALL.map((item) => (
                  <tr key={item.Id} onDoubleClick={() => Update(item)}>
                    <td>{item.Name}</td>
                    <td>{item.Address}</td>
                    <td>{item.Description}</td>
                    <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => Showw(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </div>
      <ToastContainer autoClose={1200} />
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default Mahkama;
